import React, { Component } from 'react';
import FormDropdown from '../Dropdown/FormDropdown';
import Loader from '../Loader';
import './ToolboxColumn.sass';
import { I18n } from 'react-redux-i18n';
import SquareButton from '../SquareButton';
import { remove } from 'lodash';
class ToolboxColumn extends Component {
  static defaultProps;
  constructor(props) {
    super(props);
    this.state = {
      titles: [],
      subtitles: [],
      captions: [],
      filter: {
        title: '',
        subtitle: { description: '' },
        caption: { description: '' },
        partner_ids: {
          code: undefined,
          description: I18n.t('clients.accountButton'),
        },
        branchs: {
          code: undefined,
          description: I18n.t('clients.filiar'),
        },
      },
      filterValues: {},
      loading: false,
      isAdmin: false,
      isUserAccount: false,
    };
  }
  state = {
    titles: [],
    subtitles: [],
    captions: [],
    filter: {
      title: '',
      subtitle: { description: '' },
      caption: { description: '' },
    },
    loading: false,
  };
  async componentDidMount() {
    let titles = [];
    let subtitles = [];
    let captions = [];

    // Rehydrate the selected filter from the store so the selects keep
    // showing the applied filter after a remount (e.g. tab switch).
    // partner_ids/branchs fall back to the current (default) state value
    // when the store doesn't carry them, so a cleared store (NW-2594/NW-2596)
    // still resets the dropdowns instead of keeping a stale selection.
    const { toolboxFilter } = this.props;
    const filter = toolboxFilter
      ? {
          ...this.state?.filter,
          title: toolboxFilter?.title || '',
          subtitle: toolboxFilter?.subtitle || '',
          caption: toolboxFilter?.caption || '',
          partner_ids: toolboxFilter?.partner_ids || this.state?.filter?.partner_ids,
          branchs: toolboxFilter?.branchs || this.state?.filter?.branchs,
        }
      : this.state?.filter;

    if (this.props.campaigns && this.props.profiles) {
      this.setState({
        ...this.state,
        filter,
        subtitles: this.props.profiles,
        captions: this.props.campaigns,
      });
    } else {
      await this.props.items.map((item) => {
        let subtitleExist;
        let captionExist;
        if (this.props.backendFetch) {
          subtitleExist = subtitles.findIndex(
            (subtitle) =>
              subtitle.subtitle?.description === item.subtitle?.description,
          );
          captionExist = captions.findIndex(
            (caption) =>
              caption.caption?.description === item.caption?.description,
          );
        } else {
          subtitleExist = subtitles.findIndex(
            (subtitle) => subtitle.subtitle === item.subtitle,
          );
          captionExist = captions.findIndex(
            (caption) => caption.caption === item.caption,
          );
        }
        titles.push({ title: item.title });
        if (subtitleExist === -1) subtitles.push({ subtitle: item.subtitle });
        if (captionExist === -1) captions.push({ caption: item.caption });
      });
      this.setState({
        ...this.state,
        filter,
        titles,
        subtitles,
        captions,
      });
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.items !== this.props.items) {
      let titles = [];
      let subtitles = [];
      let captions = [];
      if (this.props.toolboxFilter) {
        this.setState({
          ...this.state,
          filter: {
            ...this.state.filter,
            title: this.props.toolboxFilter?.title || '',
            subtitle: this.props.toolboxFilter?.subtitle || '',
            caption: this.props.toolboxFilter?.caption || '',
            partner_ids:
              this.props.toolboxFilter?.partner_ids ||
              this.state.filter?.partner_ids,
            branchs:
              this.props.toolboxFilter?.branchs || this.state.filter?.branchs,
          },
        });
      }
      if (this.props.campaigns && this.props.profiles) {
        this.setState({
          ...this.state,
          subtitles: this.props.profiles,
          captions: this.props.campaigns,
        });
      } else {
        await this.props.items.map((item) => {
          let subtitleExist;
          let captionExist;
          if (this.props.backendFetch) {
            subtitleExist = subtitles.findIndex(
              (subtitle) =>
                subtitle.subtitle?.description === item.subtitle?.description,
            );
            captionExist = captions.findIndex(
              (caption) =>
                caption.caption?.description === item.caption?.description,
            );
          } else {
            subtitleExist = subtitles.findIndex(
              (subtitle) => subtitle.subtitle === item.subtitle,
            );
            captionExist = captions.findIndex(
              (caption) => caption.caption === item.caption,
            );
          }

          titles.push({ title: item.title });
          if (subtitleExist === -1) subtitles.push({ subtitle: item.subtitle });
          if (captionExist === -1) captions.push({ caption: item.caption });
        });
        this.setState({
          ...this.state,
          titles,
          subtitles: this.props.profiles || subtitles,
          captions,
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  handleSelect = async (name, option) => {
    console.log('name', name, 'option', option);
    this.setState(
      {
        ...this.state,
        filter: {
          ...this.state.filter,
          [name]: option,
        },
      },
      () => {
        if (this.props.backendFetch) {
          this.props.fetch(this.state.filter);
          if (name === 'partner_ids') {
            this.setState(
              {
                ...this.state,
                filter: {
                  ...this.state.filter,
                  caption: '',
                },
              },
              () => {
                this.props.fetch(this.state.filter);
              },
            );
            this.props.getBranchs({
              account_id: this.state.filter.partner_ids.code,
            });
          }
          if (name === 'branchs') {
            this.setState(
              {
                ...this.state,
                filter: {
                  ...this.state.filter,
                  caption: '',
                },
              },
              () => {
                this.props.fetch(this.state.filter);
              },
            );
          }
        }
        if (this.props.updateToolboxFilter) {
          let name;
          switch (this.props.name) {
            case 'selectedPersons':
              name = 'toolboxFilterPersons';
              break;
            case 'selectedJobs':
              name = 'toolboxFilterJobs';
              break;
            case 'selectedSkills':
              name = 'toolboxFilterSkills';
              break;
            default:
              break;
          }
          this.props.updateToolboxFilter(name, this.state.filter);
        }
      },
    );
  };
  switchTexts = (tab, section) => {
    if (section === 'search-bar') {
      switch (tab) {
        case 'selectedJobs':
          return I18n.t('toolbox.searchJob');
        case 'selectedPersons':
          return I18n.t('toolbox.searchPerson');
        case 'selectedSkills':
          return I18n.t('toolbox.searchSkill');
        default:
          break;
      }
    }
  };

  renderPagination = () => {
    const {
      currentPage = 1,
      totalPages: propTotalPages = 1,
      pageSize: propPageSize,
      totalCount = 0,
      updatePage,
      showPagination,
      handleSelect,
      name,
    } = this.props;

    // Forzar pageSize a 1000 para GroupTrends
    const pageSize = 1000;
    // Recalcular totalPages basándose en el pageSize correcto
    const totalPages = Math.ceil(totalCount / pageSize);

    if (!showPagination || !updatePage || !totalCount || totalCount === 0) {
      return null;
    }

    const isOnFirstPage = currentPage === 1;
    const isOnLastPage = currentPage === totalPages;
    const pageStart = (currentPage - 1) * pageSize + 1;
    const pageEnd = Math.min(currentPage * pageSize, totalCount);

    // Función para cambiar de página sin limpiar la selección
    const handlePageChange = (page) => {
      updatePage(page);
    };

    // Calcular las 3 páginas a mostrar
    let pagesToShow = [];
    if (totalPages <= 3) {
      // Si hay 3 o menos páginas, mostrar todas
      for (let i = 1; i <= totalPages; i++) {
        pagesToShow.push(i);
      }
    } else {
      // Lógica para mostrar siempre 3 páginas
      if (currentPage === 1) {
        pagesToShow = [1, 2, 3];
      } else if (currentPage === totalPages) {
        pagesToShow = [totalPages - 2, totalPages - 1, totalPages];
      } else {
        pagesToShow = [currentPage - 1, currentPage, currentPage + 1];
      }
    }

    return (
      <div className="toolbox-pagination-compact">
        <div className="pagination-info-compact">
          <span>
            {pageStart}-{pageEnd} {I18n.t('pagination.of')} {totalCount}
          </span>
        </div>
        <div className="pagination-controls-compact">
          <button
            className="pagination-btn-compact"
            onClick={() => !isOnFirstPage && handlePageChange(1)}
            disabled={isOnFirstPage}
          >
            <span className="material-symbols-rounded">first_page</span>
          </button>
          <button
            className="pagination-btn-compact"
            onClick={() => !isOnFirstPage && handlePageChange(currentPage - 1)}
            disabled={isOnFirstPage}
          >
            <span className="material-symbols-rounded">chevron_left</span>
          </button>
          {pagesToShow.map((page) => (
            <button
              key={page}
              className={`pagination-page-btn ${
                page === currentPage ? 'active' : ''
              }`}
              onClick={() => page !== currentPage && handlePageChange(page)}
            >
              {page}
            </button>
          ))}
          <button
            className="pagination-btn-compact"
            onClick={() => !isOnLastPage && handlePageChange(currentPage + 1)}
            disabled={isOnLastPage}
          >
            <span className="material-symbols-rounded">chevron_right</span>
          </button>
          <button
            className="pagination-btn-compact"
            onClick={() => !isOnLastPage && handlePageChange(totalPages)}
            disabled={isOnLastPage}
          >
            <span className="material-symbols-rounded">last_page</span>
          </button>
        </div>
      </div>
    );
  };

  render() {
    const {
      title,
      headerIcon,
      items,
      handleSelect,
      name,
      selected,
      selectedIds,
    } = this.props;

    // Use the Set for more accurate selection tracking if provided (for persons)
    const isSelectedFn = selectedIds
      ? (id) => selectedIds.has(id)
      : (id) => selected.map((s) => s.id).includes(id);

    let selectedIdsArray = selectedIds
      ? Array.from(selectedIds)
      : selected.map((s) => s.id);

    let itemsFilteredLength = this.props?.items?.filter(
      (r) =>
        !selectedIdsArray.includes(r.id) &&
        (this.props.backendFetch
          ? true
          : r?.title
              ?.toLowerCase()
              .includes(this.state.filter?.title?.toLowerCase()) &&
            (r?.subtitle
              ? r?.subtitle.includes(this.state.filter?.subtitle?.description)
              : true) &&
            (r?.caption
              ? r?.caption.includes(this.state.filter?.caption?.description)
              : true)),
    ).length;
    let totalCount;
    const maxSel = this.props.maxSelection;
    if (maxSel) {
      totalCount = this.props.name === 'selectedPersons' && this.props.totalCount
        ? this.props.totalCount
        : itemsFilteredLength + selected.length;
    } else if (
      (this.props.name === 'selectedJobs' ||
        this.props.name === 'selectedSkills') &&
      itemsFilteredLength > 8
    ) {
      totalCount = 8;
    } else {
      totalCount = itemsFilteredLength + selected.length;
    }
    console.log(this.state.filter);
    return (
      <div className={`toolbox-column-container ${this.props.className}`}>
        <div className="toolbox-column-head">
          <div className="header">
            <p>{title}</p>
            {headerIcon}
          </div>
          {this.props.subHeader}
          <div
            className={`toolbox-column-filters ${
              this.props.isUserAccount ? 'user-account' : ''
            }`}
          >
            {this.props.isAdmin &&
            this.state.subtitles.length > 2 &&
            this.props.name === 'selectedPersons' ? (
              <FormDropdown
                name={'partner_ids'}
                placeholder={I18n.t('clients.accountButton')}
                emptyOption={{
                  code: undefined,
                  description: I18n.t('clients.accountButton'),
                }}
                change={this.handleSelect}
                search={this.props.getAllClients}
                value={{ inputValue: this.state.filter.partner_ids }}
                options={this.props.allClients.map((client) => ({
                  code: client.id,
                  description: client.name,
                }))}
                cleanOption
                showEmptyOption
                getAllClientsPrompts={{
                  account_dropdown: true,
                  view_branch: false,
                  view_account: true,
                }}
                dropDownClean={this.props.dropDownClean}
              />
            ) : (
              ''
            )}
            {(this.props.isAdmin || this.props.isUserAccount) &&
            this.state.subtitles.length > 2 &&
            this.props.name === 'selectedPersons' ? (
              <FormDropdown
                name={'branchs'}
                placeholder={I18n.t('clients.filiar')}
                change={this.handleSelect}
                search={true}
                value={{ inputValue: this.state.filter.branchs }}
                options={this.props.branchs?.map((client) => {
                  return {
                    code: client.id,
                    description: client.name,
                  };
                })}
                cleanOption
                showEmptyOption
                getBranchsPrompts={{
                  account_dropdown: true,
                  view_branch: true,
                  view_account: false,
                }}
                dropDownClean={this.props.dropDownClean}
              />
            ) : (
              ''
            )}

            {this.props.name === 'selectedPersons' && (
              <FormDropdown
                value={{
                  inputValue: {
                    description: this.state.filter?.caption?.description,
                    label: I18n.t('campaigns.identifier'),
                    code: this.state.filter?.caption.code || null,
                  },
                }}
                change={this.handleSelect}
                name={'caption'}
                search={true}
                options={this.state?.captions.map((captions, key) => ({
                  code: captions?.caption?.code || key,
                  description:
                    captions?.caption?.description || captions.caption,
                }))}
                getAllClientsPrompts={{
                  partners: null,
                  campaign_dropdown: true,
                }}
                cleanOption
                dropDownClean={this.props.dropDownClean}
              />
            )}
            {(this.props.name === 'selectedPersons' ||
              this.props.name === 'selectedJobs') && (
              <FormDropdown
                name={'subtitle'}
                value={{
                  inputValue: {
                    description: this.state.filter?.subtitle?.description,
                    label: I18n.t('profiles.title'),
                    code: this.state.filter?.subtitle.code || null,
                  },
                }}
                search={true}
                options={this.state?.subtitles?.map((subtitles, key) => ({
                  code: subtitles?.subtitle?.code || key,
                  description:
                    subtitles?.subtitle?.description || subtitles?.subtitle,
                }))}
                cleanOption
                change={this.handleSelect}
                dropDownClean={this.props.dropDownClean}
              />
            )}

            <div className="search-input">
              <span className="material-symbols-rounded search-icon">
                search
              </span>
              <input
                name="title"
                type="text"
                id={this.props.name}
                value={this.state.filter.title}
                className={`${this.state.filter.title !== '' && 'active'}`}
                onChange={(e) =>
                  this.setState(
                    {
                      ...this.state,
                      filter: {
                        ...this.state.filter,
                        title: e.target.value,
                      },
                    },
                    () => {
                      if (this.props.backendFetch) {
                        {
                          if (this.searchTimeout)
                            clearTimeout(this.searchTimeout);
                          this.searchTimeout = setTimeout(
                            function () {
                              this.props.fetch(this.state.filter);
                            }.bind(this),
                            500,
                          );
                        }
                      }
                      if (this.props.updateToolboxFilter) {
                        let name;
                        switch (this.props.name) {
                          case 'selectedPersons':
                            name = 'toolboxFilterPersons';
                            break;
                          case 'selectedJobs':
                            name = 'toolboxFilterJobs';
                            break;
                          case 'selectedSkills':
                            name = 'toolboxFilterSkills';
                            break;
                          default:
                            break;
                        }
                        this.props.updateToolboxFilter(name, this.state.filter);
                      }
                    },
                  )
                }
                placeholder={this.switchTexts(name, 'search-bar')}
              />
            </div>
            <p
              onClick={() =>
                this.props.handleSelect(this.props.name, 'remove-all')
              }
              className={`remove-selection ${
                this.props?.selected?.length ? '' : 'invisible'
              }`}
            >
              <span className="material-symbols-rounded">close</span>
              {I18n.t('toolbox.clearSelection')}
            </p>
          </div>
        </div>
        <div className="toolbox-column-body">
          <div
            id="scroll-area"
            className={`items ${name === 'selectedSkills' && 'long-scroll'} ${
              selected.length ? 'some-items-selected' : ''
            } ${
              (this.props.isAdmin || this.props.isUserAccount) && 'short-scroll'
            }`}
          >
            {this.props.isSelectingAll ? (
              <div className="toolbox-pagination-loader-centered">
                <Loader mini />
              </div>
            ) : this.props.loading && this.props.showPagination ? (
              <div className="toolbox-pagination-loader-centered">
                <Loader mini />
              </div>
            ) : items.length > 0 || selected.length > 0 ? (
              items
                .filter((r) =>
                  this.props.backendFetch
                    ? true
                    : r?.title
                        ?.normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        ?.toLowerCase()
                        .includes(
                          this.state.filter?.title
                            ?.normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .toLowerCase(),
                        ) &&
                      (r?.subtitle
                        ? r?.subtitle
                            ?.normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            ?.includes(
                              this.state.filter?.subtitle?.description
                                ?.normalize('NFD')
                                .replace(/[\u0300-\u036f]/g, ''),
                            )
                        : true) &&
                      (r?.caption
                        ? r?.caption
                            ?.normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            ?.includes(
                              this.state.filter?.caption?.description
                                ?.normalize('NFD')
                                .replace(/[\u0300-\u036f]/g, ''),
                            )
                        : true),
                )
                .map((item, index) => {
                  let length = [];
                  if ('title' in item) {
                    length.push(1);
                  }
                  if ('subtitle' in item) {
                    length.push(1);
                  }
                  if ('caption' in item) {
                    length.push(1);
                  }
                  if (
                    item.subtitle?.description === undefined &&
                    this.props.name === 'selectedPersons'
                  )
                    return;
                  return (
                    <>
                      <SquareButton
                        id={item.id}
                        key={item.id}
                        class={index + 1 === items.length ? 'last-item' : ''}
                        description={item.description}
                        change={handleSelect}
                        name={name}
                        setValue={item}
                        disabled={
                          this.props.maxSelection
                            ? this.props.selected.length >= this.props.maxSelection &&
                              !isSelectedFn(item.id)
                            : ((this.props.name === 'selectedJobs' ||
                                this.props.name === 'selectedSkills') &&
                                this.props.selected.length >= 8 &&
                                !this.props?.selected?.find(
                                  (select) => select.id === item.id,
                                )) ||
                              (this.props.name === 'selectedPersons' &&
                                this.props.selected.length >= 5000 &&
                                !isSelectedFn(item.id))
                        }
                        value={{
                          inputValue: isSelectedFn(item.id),
                        }}
                        labelBody={
                          <div className={`item value-${length.length}`}>
                            <div className="title">{item.title}</div>
                            <div className="sub-title">
                              {item.subtitle?.description
                                ? item.subtitle.description
                                : typeof item.subtitle !== 'object'
                                ? item.subtitle
                                : ''}
                            </div>
                            <div className="caption">
                              {item.caption?.description
                                ? item.caption.description
                                : typeof item.caption !== 'object'
                                ? item.caption
                                : ''}
                            </div>
                          </div>
                        }
                      />
                    </>
                  );
                })
            ) : this.props.totalCount === 0 ||
              this.props.totalCount === undefined ? (
              ''
            ) : (
              <Loader mini />
            )}
          </div>
        </div>
        <div className="toolbox-column-footer">
          <div className="bottom-text">
            {this.props.loading && this.props.showPagination ? (
              <p className="selected">
                {I18n.t('toolbox.selected', {
                  selected: 0,
                  total: 0,
                })}
              </p>
            ) : (
              <>
                <p className="selected">
                  {I18n.t('toolbox.selected', {
                    selected:
                      this.props.selectedIds?.size ??
                      this.props?.selected?.length,
                    total:
                      this.props.name === 'selectedPersons' &&
                      this.props.totalCount != null
                        ? this.props.totalCount
                        : items.length,
                  })}
                  {this.props.maxSelection && (
                    <span>{` (máx. ${this.props.maxSelection})`}</span>
                  )}
                </p>
                {this.props.name.includes('selectedPersons') &&
                  !this.props.maxSelection && (
                    <p
                      className={`select-all ${
                        this.props.selected.length >= 5000 ? 'disabled' : ''
                      }`}
                      onClick={() => {
                        if (this.props.selected.length >= 5000) return;
                        this.props.handleSelect(
                          this.props.name,
                          'add-all',
                          items,
                        );
                      }}
                      style={{
                        cursor:
                          this.props.selected.length >= 5000
                            ? 'not-allowed'
                            : 'pointer',
                        opacity:
                          this.props.selected.length >= 5000 ? 0.5 : 1,
                      }}
                    >
                      {I18n.t('toolbox.selectPage')}
                    </p>
                  )}
              </>
            )}
          </div>
        </div>
        {this.renderPagination()}
      </div>
    );
  }
}

export default ToolboxColumn;
